import PropTypes from 'prop-types';
import React from 'react';
import { Typography } from '@sm/wds-react';

import EnterprisePackageCta from '../EnterprisePackageCta';
import { packageLabelToClassName } from '~pricing/lib/helpers';

const EnterprisePackageHeader = ({ details }) => {
  const packageClassName = packageLabelToClassName(details);

  return (
    <header
      className={`sm-package__header sm-package--border-${packageClassName}`}
      data-testid="EnterprisePackageHeader_Header"
    >
      <Typography
        component="h1"
        variant="sectionTitle"
        className="sm-package__title"
        data-testid="EnterprisePackageHeader_H1"
      >
        {details.displayName}
      </Typography>
      <Typography component="h2" variant="body">
        Powerful admin tools, integrations, and collaboration features for your
        organization.
      </Typography>
      <EnterprisePackageCta />
    </header>
  );
};

EnterprisePackageHeader.propTypes = {
  details: PropTypes.shape({
    displayName: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
  }).isRequired
};

export default EnterprisePackageHeader;
